module.exports = __webpack_public_path__ + "img/course102_summary_unit_timelines.1c1d6372.png";